import React from "react";
import { Spin, Select } from "antd";

import { compose, config } from "src/helpers";
import { Field, RenderSelect } from "src/components";

import { withMemes } from "src/modules/meme/operations";

import { withStateAndActionsForMeme } from "../resolvers";

const Option = Select.Option;

const SubjectsField = (props) => {
    const { loading, memes, where, onNameChange, onChange, value } = props;

    return (
        <Field
            labelInValue
            showSearch={true}
            filterOption={false}
            onSearch={onNameChange}
            notFoundContent={loading ? <Spin size="small" /> : null}
            name={"memes"}
            component={RenderSelect}
            placeholder={"Memes"}
            label={"Memes"}
            value={value || "None"}
            loading={loading}
            onChange={onChange}
            inFilter={true}
            noBotMarging={true}
        >
            {[
                // config.EMPTY_OPTION,
                ...(memes?.map((meme) => ({
                    id: meme.id,
                    label: meme.name || "",
                    value: JSON.stringify(meme),
                })) || []),
            ]?.map(
                ({
                    id,
                    value,
                    label = "",
                }: {
                    id: string;
                    value: string;
                    label: string;
                }) => (
                    <Option key={id} value={value}>
                        {label}
                    </Option>
                ),
            )}
        </Field>
    );
};

export default compose(withStateAndActionsForMeme, withMemes)(SubjectsField);
